import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { BuyIcon } from '@root/shared/ui-kit'

import { InstantTradeWalletBalance } from '../instant-trade-swap/instant-trade-wallet-balance'

import type { PairModel } from '@root/entities/pair'
import type { TradeType } from '@root/entities/trade-type'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  direction: TradeType.SwapDirection
  pair: PairModel
} & ClassNameProps

export const InstantTradeBottomDirectionLabel: React.FC<Props> = ({
  className,
  direction,
  pair,
}) => {
  const { t } = useTranslation()

  return (
    <Root className={className}>
      <LabelContainer data-direction={direction}>
        <BuyIcon size={14} />
        <Label>
          {direction === 'buy' ? t('trading.buy') : t('trading.sell')}
        </Label>
      </LabelContainer>
      <Balance swapDirection={direction} pair={pair} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  justify-items: start;
  margin-inline-end: 8px;
`

const Label = styled.div`
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  text-transform: uppercase;
`

const LabelContainer = styled.div`
  &[data-direction='sell'] {
    color: var(--downAccent-9);
  }
  &[data-direction='buy'] {
    color: var(--upAccent-9);
  }

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;
  margin-bottom: 2px;
`

const Balance = styled(InstantTradeWalletBalance)`
  && {
    --wallet-balance-height: 20px;
  }
`
